export const pathNamePages = {
  home: "/",
  administracionAlertas: "/administracionAlertas",
  administracionInformes: "/administracionInformes",
  pruebaNotificaciones: "/pruebaNotificaciones",
  administracionNotificaciones: '/administracionNotificacionesInternas',
};
